export const objectToUrlParams = (objectParams) => {
  if (typeof objectParams === 'object') {
    const params = new URLSearchParams(objectParams);
    return `?${params.toString()}`;
  }
  return '';
};
